import { QrCode } from "@/components/features/qr-code-link"

export const QRCodeLinkPage = () => <QrCode />
